module.exports = __webpack_public_path__ + "static/img/cont35 (3).117b843.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont35 (3).jpg
// module id = U6Z/
// module chunks = 0